export class DocumentEvents {
    public static readonly FullTextLoaded = "FullTextLoaded";
    public static readonly HighlightAllQuotedParagraphs = "HighlightAll";
    public static readonly ShowPowerPara = "ShowPowerPara";
    public static readonly ToggleCIC = "ToggleCIC";
    public static readonly CICEngaged = "CICEngaged";
    public static readonly CICRemoveAll = "CICRemoveAll";
    public static readonly DocumentRefreshed = "DocumentRefreshed";
    public static readonly AllQuotedParagraphsToggle = "AllQuotedParagraphsToggle";
    public static readonly CiteLineEngaged = "CiteLineEngaged";
    public static readonly CiteLineDisengaged = "CiteLineDisengaged";
    public static readonly CompactChanged = "CompactChanged";
    public static readonly GainedFocus = "GainedFocus";
    public static readonly RequestConsideredCICCounts = "RequestConsideredCICCounts";
    public static readonly CICCountsReady = "CICCountsReady";

}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/desktop/helpers/document-events.ts